<template>
  <div class="text-xs-center">
    <v-dialog
      :value="modalState"
      fullscreen
    >
      <v-card>
        <v-tabs
          v-model="active"
          color="teal"
          slider-color="white"
        >
          <v-tab class="pa-3">
            Einloggen
          </v-tab>
          <v-tab class="pa-3">
            Registrieren
          </v-tab>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="closeModal"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-tab-item>
            <v-container fluid>
              <v-layout
                justify-center
                row
              >
                <v-flex
                  xs12
                  md8
                  lg6
                >
                  <v-card flat>
                    <v-card-text>
                      <p
                        class="subheading white--text font-weight-light mb-5"
                      >
                        Bitte gib deine Anmeldedaten hier ein.
                        <br>
                        <span class="font-italic"> (Falls du noch keinen Account hast, kannst du dich <a @click="next">hier</a> registrieren).</span>
                      </p>
                      <v-form
                        ref="login"
                        v-model="loginValid"
                        validation
                      >
                        <v-text-field
                          v-model="loginEmail"
                          prepend-icon="email"
                          name="email"
                          label="E-Mail"
                          type="email"
                          :rules="loginEmailRules"
                        />

                        <v-text-field
                          v-model="loginPassword"
                          prepend-icon="lock"
                          name="password"
                          label="Passwort"
                          type="password"
                          :counter="6"
                          :rules="loginPasswordRules"
                        />
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        flat
                        color="white"
                        :loading="loading"
                        :disabled="!loginValid || loading"
                        @click="onLogin"
                      >
                        Anmelden
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>

          <v-tab-item>
            <v-container fluid>
              <v-layout
                justify-center
                row
              >
                <v-flex
                  xs12
                  md8
                  lg6
                >
                  <v-card flat>
                    <v-card-text>
                      <p
                        class="subheading white--text font-weight-light mb-5"
                      >
                        Wennds de omiadsd konsd Favoriten speichern. Des findsd nachad im Reiter "Favoriten".
                      </p>
                      <v-form
                        ref="registration"
                        v-model="regValid"
                        validation
                      >
                        <v-text-field
                          v-model="regEmail"
                          class="text-field"
                          prepend-icon="email"
                          name="email"
                          label="E-mail"
                          type="email"
                          :rules="regEmailRules"
                        />

                        <v-text-field
                          v-model="regPassword"
                          prepend-icon="lock"
                          name="password"
                          label="Passwort"
                          type="password"
                          :counter="6"
                          :rules="regPasswordRules"
                        />

                        <v-text-field
                          v-model="confirmRegPassword"
                          prepend-icon="lock"
                          name="confirm-password"
                          label="Passwort bestätigen"
                          type="password"
                          :counter="6"
                          :rules="confirmRegPasswordRules"
                        />
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        flat
                        color="white"
                        :loading="loading"
                        :disabled="!regValid || loading"
                        @click="onRegister"
                      >
                        Registrieren
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
// eslint-disable-next-line no-useless-escape
const emailRE = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  data() {
    return {
      dialog: false,
      active: null,
      loginEmail: '',
      regEmail: '',
      loginPassword: '',
      regPassword: '',
      confirmRegPassword: '',
      loginValid: false,
      regValid: false,
      loginEmailRules: [
        v => !!v || 'Ja a E-Mail missasd scho eigem',
        v => emailRE.test(v) || 'Ah geh weida! So a E-Mail-Adress gibts doch ned!',
      ],
      regEmailRules: [
        v => !!v || 'Ja a E-Mail missasd scho eigem',
        v => emailRE.test(v) || 'Ah geh weida! So a E-Mail-Adress gibts doch ned!',
      ],
      loginPasswordRules: [
        v => !!v || 'So a zeig mit dem Passwort, ha? Des muas oba sei!',
        v => (v && v.length >= 6) || 'Aiso Dei Passwort soid mind. 6 Zeichen hom',
      ],
      regPasswordRules: [
        v => !!v || 'So a zeig mit dem Passwort, ha? Des muas oba sei!',
        v => (v && v.length >= 6) || 'Aiso Dei Passwort soid mind. 6 Zeichen hom',
      ],
      confirmRegPasswordRules: [
        v => !!v || 'Ja mist. Nummoi eigem!',
        v => v === this.regPassword
          || 'De zwoa Passwörter missadn scho gleich sei.',
      ],
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    modalState() {
      return this.$store.getters.modal;
    },
  },
  methods: {
    onRegister() {
      if (this.$refs.registration.validate()) {
        const user = {
          email: this.regEmail,
          password: this.regPassword,
        };

        this.$store.dispatch('registerUser', user);
      }
    },
    onLogin() {
      if (this.$refs.login.validate()) {
        const user = {
          email: this.loginEmail,
          password: this.loginPassword,
        };

        this.$store.dispatch('loginUser', user);
      }
    },
    closeModal() {
      this.$store.commit('closeUserModal');
    },
    next() {
      const active = parseInt(this.active, 10);
      this.active = (active < 2 ? active + 1 : 0);
    },
  },
};
</script>
